import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import * as Sentry from "@sentry/browser"
import selectArticleFromSearchAction from "cc-frontend/lib/actions/app-state/KB_SELECT_ARTICLE_FROM_SEARCH"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { compact, first, isNil, last, map, truncate } from "lodash-es"
import { tracked } from "tracked-built-ins"

interface Signature {
  Element: HTMLDivElement
  Args: {
    searchBarClass: string
  }
}

export default class KbSearch extends Component<Signature> {
  @service declare dispatcher: Dispatcher

  @service declare algolia

  @service router

  @tracked selected: Array<any> = []
  @tracked matches: Array<any> = []
  @tracked articles: Array<any> = []
  @tracked searchTerm: string | null = null

  @action onDidInsertElement() {
    return this.algolia.help.search("").then((data) => {
      if (this.isDestroyed || this.isDestroying) return
      this.articles = data.hits
    })
  }

  @action searchAlgolia(searchQuery) {
    let term = truncate(searchQuery, { length: 511 })
    this.searchTerm = term
    return this.algolia.help
      .search(term)
      .then((data) => {
        let results = map(data.hits, (hit) => {
          return {
            id: hit.id,
            attributes: {
              title: hit._highlightResult.attributes.title.value,
            },
            relationships: {
              ancestors: hit.relationships.ancestors,
            },
          }
        })
        if (this.isDestroyed || this.isDestroying) return
        this.matches = results
        return results
      })
      .catch(function (err) {
        console.error(err)
        Sentry.withScope((scope) => {
          scope.setLevel(Sentry.Severity.Error)
          scope.setExtra("error", err)
          Sentry.captureMessage("Algolia search error")
        })
      })
  }

  @action selectArticle(the_matches) {
    let matches = compact(the_matches)
    let match
    if (matches.length === 0) {
      match = first(this.matches)
    } else {
      match = first(matches)
    }
    if (isNil(match)) return
    let ancestorIds = map(match.relationships.ancestors.data, (ancestor) => ancestor.id)
    let parentId = last(ancestorIds)
    this.dispatcher.dispatchPreparedAction(
      selectArticleFromSearchAction({
        searchQuery: this.searchTerm,
        articleTitle: match.attributes.title,
        articleId: match.id,
        ancestorIds: ancestorIds,
        parentId: parentId,
      })
    )
    this.router.transitionTo("help.article", match.id)
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Kb::Search::Main": typeof KbSearch
  }
}
